// Head pitch from MediaPipe FaceLandmarker's facial transformation matrix (4×4, column-major).
// The face's forward axis in camera space is the matrix's 3rd column (m[8], m[9], m[10]). In MediaPipe's
// right-handed, y-up camera space a face tilting DOWN points that axis downwards (negative y), so
// pitchDown = asin(−m[9]) is positive when looking down. Detection is always relative to the candidate's
// own baseline, so a camera above/below the eyes does not matter.
// ⚠ The sign convention is confirmed only in the live test (look down at noted times); flip DOWN_SIGN if needed.
export const DOWN_SIGN = 1;

export function pitchDownDegrees(matrix) {
  const m = matrix && (matrix.data || matrix);
  if (!m || m.length < 16) return null;
  const y = Math.max(-1, Math.min(1, -m[9] * DOWN_SIGN));
  return (Math.asin(y) * 180) / Math.PI;
}

/** Column-major 4×4 rotation about the x axis by `deg` (positive = looking down) — for tests/calibration checks. */
export function matrixForPitch(deg) {
  const r = ((deg * Math.PI) / 180) * DOWN_SIGN;
  const c = Math.cos(r);
  const s = Math.sin(r);
  // forward axis (0, -sin, cos): looking down tips it towards −y
  return [1, 0, 0, 0, 0, c, s, 0, 0, -s, c, 0, 0, 0, 0, 1];
}
